import { useEffect, useState } from 'react';
import type { ControllerRenderProps, FieldError } from 'react-hook-form';
import { Input } from '#components/atoms/forms/index.ts';
import { stringifyPortRange } from '../../stringify-port-range/stringifyPortRange.ts';
import type { FormData } from '../../types.ts';
import { parsePorts } from './parsePorts.ts';

type Props = Omit<React.ComponentPropsWithRef<'input'>, 'value'> &
  Omit<ControllerRenderProps<FormData, `firewallRules.${number}.portRange`>, 'name' | 'ref'> & {
    error: FieldError | null;
    className?: string;
  };

export function PortsInput({ value, onChange, error, disabled, ref, ...props }: Props) {
  const [text, setText] = useState<string>(() => stringifyPortRange(value));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    setText(val);
    onChange(parsePorts(val));
  };

  // If the field is disabled, set its value to null
  useEffect(() => {
    if (disabled && value !== null) {
      onChange(null);
    }
  }, [disabled, value, onChange]);

  return (
    <Input
      onChange={handleChange}
      // If the input is disabled, the value should be unused/empty
      value={disabled ? '' : text}
      hasError={Boolean(error)}
      {...props}
      disabled={disabled}
      name="portRange"
      ref={ref}
    />
  );
}
